import options from './proximity.component';


export default {
    selector: "dtEmulatorProximity",
    options
}